// extracted by mini-css-extract-plugin
export default {"buttonPlayground":"buttonPlayground-kH1DA","contents":"contents-iC6ve","item":"item-LEXmD","label":"label-Awx69","button":"button-weZxW"};